<template>
    <div v-if="isUserAuthenticated()">
        <v-dialog :value="value" @input="$emit('input', $event)" max-width="500px">
            <!-- <v-btn slot="activator" color="primary" dark class="mb-2" @click="createItem()">Nouveau contrat</v-btn> -->
            <v-card>
            <v-card-title>
                <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text style="padding-top:0px;padding-bottom:0px;">
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-container grid-list-md>
                    <v-layout wrap>
                        <!-- CustomerID:{{this.CustomerID}} -->
                        <v-flex xs12 sm12 md12>
                          <v-text-field v-model="this.CustomerName" label="Nom à facturer" disabled hide-details></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field v-model="this.AddressSnowRemovalFullAddress" label="Adresse de déneigement" disabled hide-details></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12 v-if="this.CustomerID > 0">
                          <GridCustomerPhoneNote :customerId="this.CustomerID"></GridCustomerPhoneNote>
                        </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close">Fermer</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import auth from '@/auth'
import GridCustomerPhoneNote from '@/components/GridCustomerPhoneNote.vue'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import APICustomerPhoneNote from '@/api/customerphonenote'
const APIService = new APICustomerPhoneNote();
var axios = require('axios')

export default {
   props: {
    CustomerID : {type: Number, required: true},
    CustomerName: {type: String, required: true },
    AddressSnowRemovalFullAddress: {type: String, required: true },
    value: { type: Boolean, required: true },
    //CallBackSave: { type: Function, required: true }
  },
  components:
  {
    TemplateAdminComponent,
    GridCustomerPhoneNote
  },

  mounted() {
    this.$refs.form.resetValidation()
    //$('#date').datepicker()
    //$('#date').hide();
    //this.initialize()
    //debugger;
  },

  data() {
    //debugger;
    return {
        loading: false,
        search: '',
        pagination: {
          sortBy: 'Name',
          page: 1,
          rowsPerPage: 10
        },
        headers : [
          { text: 'Date', value: 'Date', align: 'left' },
          { text: 'Note', value: 'Note', align: 'left' },
          { text: 'Actions', value: 'Actions', align: 'center', sortable: false }
        ],
        valid: false,
        requiredRules: [
          (v) => !!v || 'Field is required.',
        ],
        //items: [],
        editedItem: {},
        defaultItem: {
          Date: 0.00,
          Note: '',
          IsActive: true
        }
    }
  },

  computed: {
    formTitle () {
      //return this.props["contract"].ID <= 0 ? 'Nouveau contrat' : 'Modification du contrat'
      //return this.contract.ID <= 0 ? 'Nouveau contrat' : 'Modification du contrat'
      return 'Modification des notes téléphoniques'
    },

    pages () {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null)
        return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },

  watch: {
    items () {
      this.$nextTick(() => {
        this.pagination.totalItems = this.items.length
      })
    },
    CustomerID () {
      this.initialize()
    }
    // ID : {
    //   immediate: true,
    //   handler: function (val, oldVal) {
    //     debugger;
    //     this.initialize()
    //   }
    // }
  },

  created(){
    this.initialize()
    //alert("created")
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated()
    },

    logout() {
      auth.logout()
    },

    initialize () {
      if (this.CustomerID > 0)
      {
        APIService.getAll(this.CustomerID).then(response =>  {
            //this.items = response.data
            this.editedItem = response.data
          }
        )
      }
      else
      {
        this.editedItem = Object.assign({}, this.defaultItem)
      }
    },

    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },

    close () {
      this.$emit('input', false)
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      }, 300)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ModalPhoneNote.vue